/* LAZO — urgencia honesta y guarda de pedido mínimo
   1) Cuenta atrás del código PRIMERA10: caduca sola el 30 de septiembre.
   2) Corte de las 15:00 y fecha estimada de entrega, en hora de Madrid.
   3) Pedido mínimo de 20 €: por debajo, un pedido pierde dinero (los
      costes fijos por pedido son 10,23 €).
   Si el JavaScript falla, el HTML de partida ya dice la verdad.        */

(function () {
  'use strict';

  var MINIMO = 2000; /* céntimos */

  function pad(n) { return String(n).padStart(2, '0'); }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function madridNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
  }
  function esLaborable(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function sumaLaborables(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (esLaborable(r)) n--; }
    return r;
  }
  function fecha(d) {
    return d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  /* ---------- 1. Cuenta atrás de la promoción ---------- */
  function promo() {
    var el = document.querySelector('[data-lazo-promo]');
    if (!el) return;
    var ends = new Date(el.getAttribute('data-ends')).getTime();
    var caja = el.querySelector('.lazo-bar__promo');
    var base = el.querySelector('.lazo-bar__base');
    var out = el.querySelector('.lazo-count');
    if (!caja || !base || !out || isNaN(ends)) return;
    var timer = null;

    function tick() {
      var left = ends - Date.now();
      if (left <= 0) { caja.hidden = true; base.hidden = false; if (timer) clearInterval(timer); return; }
      caja.hidden = false; base.hidden = true;
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var x = s % 60;
      out.textContent = d > 0
        ? 'Termina en ' + d + ' d ' + h + ' h ' + m + ' min'
        : 'Termina en ' + pad(h) + ':' + pad(m) + ':' + pad(x);
    }
    tick();
    timer = setInterval(tick, 1000);

    var btn = el.querySelector('[data-lazo-code]');
    if (btn && navigator.clipboard) {
      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(btn.getAttribute('data-lazo-code')).then(function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
        });
      });
    }
  }

  /* ---------- 2. Corte de las 15:00 y fecha de entrega ---------- */
  function entrega() {
    var el = document.querySelector('[data-lazo-cutoff]');
    if (!el) return;

    var ahora = madridNow();
    var corte = new Date(ahora.getTime());
    corte.setHours(15, 0, 0, 0);

    var salida, cabecera;
    if (esLaborable(ahora) && ahora < corte) {
      salida = ahora;
      var falta = corte - ahora;
      var h = Math.floor(falta / 3600000);
      var m = Math.floor((falta % 3600000) / 60000);
      cabecera = 'Pídelo en <strong>' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min') + '</strong> y sale hoy mismo.';
    } else {
      salida = sumaLaborables(ahora, 1);
      cabecera = 'Sale el <strong>' + fecha(salida) + '</strong>.';
    }

    el.innerHTML = cabecera +
      ' Llega a península entre el <strong>' + fecha(sumaLaborables(salida, 1)) +
      '</strong> y el <strong>' + fecha(sumaLaborables(salida, 2)) +
      '</strong>. <span class="lazo-cutoff__nota">Días laborables, sin contar festivos. Baleares y Portugal, un día más.</span>';
    el.hidden = false;
  }

  /* ---------- 3. Pedido mínimo ----------
     Un pedido por debajo de 20 € no cubre los 10,23 € de costes fijos.
     Esto es una guarda de tienda, no una regla del checkout: bloquea el
     botón y explica cuánto falta. Un bloqueo duro de verdad necesitaría
     una Shopify Function o una app.                                    */

  var SEL_CHECKOUT = '[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]';

  function pintaAviso(ancla, falta) {
    var n = document.querySelector('.lazo-min');
    if (!n) {
      n = document.createElement('p');
      n.className = 'lazo-min';
      n.setAttribute('role', 'status');
    }
    n.textContent = 'Pedido mínimo de 20 €. Te faltan ' + eur(falta) + ' para poder finalizar.';
    if (ancla && ancla.parentNode) ancla.insertAdjacentElement('beforebegin', n);
    return n;
  }

  function quitaAviso() {
    var n = document.querySelector('.lazo-min');
    if (n && n.parentNode) n.parentNode.removeChild(n);
  }

  function minimo() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest(SEL_CHECKOUT);
      if (!b) return;
      if (b.getAttribute('data-lazo-visto') === '1') {
        b.removeAttribute('data-lazo-visto');
        return;
      }
      ev.preventDefault();
      ev.stopPropagation();
      b.setAttribute('aria-busy', 'true');

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          b.removeAttribute('aria-busy');
          if (c.total_price >= MINIMO) {
            quitaAviso();
            window.location.href = '/checkout';
          } else {
            var n = pintaAviso(b, MINIMO - c.total_price);
            n.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        })
        .catch(function () {
          b.removeAttribute('aria-busy');
          b.setAttribute('data-lazo-visto', '1');
          b.click();
        });
    }, true);

    /* En la página del carrito, avisar antes de que lo intente */
    if (location.pathname.indexOf('/cart') === 0) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c.item_count > 0 && c.total_price < MINIMO) {
            var b = document.querySelector(SEL_CHECKOUT);
            if (b) pintaAviso(b, MINIMO - c.total_price);
          }
        })
        .catch(function () {});
    }
  }

  function init() { promo(); entrega(); minimo(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
